module.exports = __webpack_public_path__ + "media/05.6d20d0e2.mp3";